import * as ordersApi from "@/apiv2/planner/orders";

import { handleError } from "../../utils/error";
import * as routerSelectors from "../../router/router.selectors";

import * as selectors from "./statusFilter.selectors";
import {
  SET_IS_FETCHING_STATUSES,
  SET_STATUSES,
  SET_SELECTED_STATUSES,
  RESET,
} from "./statusFilter.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setStatuses = (data) => (dispatch) => {
  dispatch({
    type: SET_STATUSES,
    payload: data,
  });
};

export const setSelectedStatuses = (data) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_STATUSES,
    payload: data,
  });
};

export const setIsFetchingStatuses = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_FETCHING_STATUSES,
    payload: status,
  });
};

export const fetchStatuses = () => async (dispatch) => {
  try {
    dispatch(setIsFetchingStatuses(true));
    const response = await ordersApi.getAllStatuses()();

    dispatch(
      setStatuses([
        ...[
          { uid: "Draft", name: "Draft" },
          { uid: "Quote", name: "Quote" },
          { uid: "Archived", name: "Archived" },
          { uid: "Delivered", name: "Delivered" },
          { uid: "Picked Up", name: "Picked Up" },
        ],
        ...response.data,
      ])
    );

    dispatch(setSelectedStatuses([...response.data.map((r) => r.name)]));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetchingStatuses(false));
  }
};

export const setStatusFilter = (name) => (dispatch, getState) => {
  const state = getState();

  const selectedStatuses = selectors.getSelectedStatuses(state);
  const allStatuses = selectors.getStatuses(state);

  if (name === "" && selectedStatuses.length === allStatuses.length) {
    return dispatch(setSelectedStatuses([]));
  }

  if (
    name === "" &&
    (selectedStatuses.length === 0 || selectedStatuses.length < allStatuses.length + 1)
  ) {
    return dispatch(setSelectedStatuses(allStatuses.map((a) => a.name)));
  }

  if (selectedStatuses.includes(name)) {
    return dispatch(
      setSelectedStatuses(selectedStatuses.filter((statusName) => statusName !== name))
    );
  }

  return dispatch(setSelectedStatuses([...selectedStatuses, name]));
};

export const selectAllStatuses = () => (dispatch, getState) => {
  const state = getState();
  const statuses = selectors.getStatuses(state);

  dispatch(
    setSelectedStatuses([
      ...statuses
        .filter((s) => !["Draft", "Quote", "Archived", "Delivered", "Picked Up"].includes(s.name))
        .map((r) => r.name),
    ])
  );
};

export const selectAllStatusesFromQueryParams = () => (dispatch, getState) => {
  const state = getState();
  const queryParams = routerSelectors.getQuery(state);

  if (queryParams.statuses) {
    dispatch(
      setSelectedStatuses(
        Array.isArray(queryParams.statuses) ? queryParams.statuses : [queryParams.statuses]
      )
    );
  } else {
    dispatch(setSelectedStatuses([]));
  }
};
